import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../../../shared/index';

import { GenerateVoucherComponent } from './generate-voucher/generate-voucher.component';
import { SimulateBookingComponent } from './simulate-booking/simulate-booking.component';
import { ValidateVoucherComponent } from './validate-voucher/validate-voucher.component';
import { VoucherResultBoxComponent } from './voucher-result-box/voucher-result-box.component';
import { VouchersComponent } from './vouchers.component';

@NgModule({
  imports: [SharedDependenciesModule],
  declarations: [
    VouchersComponent,
    VoucherResultBoxComponent,
    GenerateVoucherComponent,
    ValidateVoucherComponent,
    SimulateBookingComponent,
  ],
  exports: [
    VouchersComponent,
    VoucherResultBoxComponent,
    GenerateVoucherComponent,
    ValidateVoucherComponent,
    SimulateBookingComponent,
  ],
})
export class VouchersModule {}
